import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { inAndroidApp } from "./install";

type Native = { shellVersion(): string; hasDevice(): boolean; setDevice(device: string, since: string): void; clearDevice(): void };
/** Present only inside the Android app, and only in versions that can show notifications. */
export const nativeApp = (window as { MangoMoonsNative?: Native }).MangoMoonsNative;

const newer = (a: string, b: string) => a.localeCompare(b, undefined, { numeric: true }) > 0;

/** Inside the Android app: a bar offering the newer app when one has been published. The screens themselves always update on their own. */
export function AppUpdateNotice() {
  const [version, setVersion] = useState("");
  useEffect(() => {
    if (!inAndroidApp) return;
    const installed = /MangoMoonsApp\/([\d.]+)/.exec(navigator.userAgent)?.[1] ?? "0";
    fetch("./android-version.json", { cache: "no-store" }).then((response) => response.ok ? response.json() : null)
      .then((latest: { version?: string } | null) => { if (latest?.version && newer(latest.version, installed)) setVersion(latest.version); }).catch(() => undefined);
  }, []);
  if (!version) return null;
  // The version in the address keeps a phone from handing back an older copy it saved; the shell (0.3.41 and later) opens
  // the download in the phone's browser straight away instead of trying to show the file first.
  const href = new URL(`./mango-moons.apk?v=${version}`, location.href).href;
  const native = (window as { MangoMoonsNative?: { download?: (url: string) => void } }).MangoMoonsNative;
  return <a href={href} download onClick={(event) => { if (native?.download) { event.preventDefault(); native.download(href); } }} className="flex items-center justify-center gap-2 rounded-xl border border-gold/40 bg-gold/10 px-4 py-3 text-sm font-semibold text-gold">
    <Download size={16}/> App update {version} is ready — tap to download, then open it to install</a>;
}
